const server = {
    UAT_PEGA_API: import.meta.env.VITE_APP_UAT_PEGA_API || '',
    UAT_MAIN_DOMAIN: import.meta.env.VITE_APP_UAT_MAIN_DOMAIN || ''
};

const enets = {
    UAT_BASE_URL: import.meta.env.VITE_APP_ENETS_BASE_URL || '',
    IP: import.meta.env.VITE_APP_ENETS_IP || '',
    B2S: 'b2stxnendurl',
    S2S: 's2stxnendurl'
};

const endpoint = {
    AUTHENTICATE: '/authenticate',
    CASES: '/case_iris',
    CASETYPES: '/casetypes',
    VIEWS: '/views',
    ASSIGNMENTS: '/assignments',
    ACTIONS: '/actions',
    PAGES: '/pages',
    DATA: '/data_iris',
    REFRESH: '/refresh',
    CERTIFICATE: '/attachments',
    DRAFTS: '/drafts',
    ATTACHMENTS: '/attachments/upload',
    GETMESSAGES: '/data_iris/D_GetApplicationCommByAppRefNo?AppRefNo=',
    GETLICENCEMESSAGES: '/data_iris/D_GetLICCommByAppRefNo?AppRefNo=',
    GETMESSAGEFILE: '/data_iris/D_GetApplicationCommsAttachments?pyGUID=',
    GETLICENCEMESSAGEFILE: '/data_iris/D_GetLICCommsAttachments?pyGUID=',
    GET_INVOICE_ERROR: 'data_iris/D_GetInvoiceErrorListByAppRefNo',
    GET_INVOICE_SUCCESS: 'data_iris/D_GetListInvoiceDataByAppRefNo',
    GET_PAYMENT_LOG: 'data_iris/D_GetListEnetsPaymentLog',
    GET_INVOICE_CASE: '/data_iris/D_GetInvoiceListByLicenceNumber?LicenceID=',
    GET_EQUIPMENT_TYPE: '/data_iris/D_GetEquipmentType',
    GET_MEDIA_LIBRARY: 'data_iris/D_MediaLibraryByCaseID?CaseID='
};

const misc = {
    REACT_APP_DEPLOYED_TIME: import.meta.env.VITE_APP_DEPLOYED_TIME
};

export { server, endpoint, enets, misc };
